import type { Map as MapboxMap } from 'mapbox-gl'

/** Interrupt any in-flight camera motion and ease to an asset view. */
export function flyMapToAsset(
  map: MapboxMap,
  center: [number, number],
  zoom: number,
): void {
  map.stop()
  map.easeTo({
    center,
    zoom,
    duration: 600,
    essential: true,
  })
}
